import { createSelector } from 'reselect';
import { get } from 'lodash';
import { getCurrentLeg } from './screen';
import { useSelector } from 'react-redux';

export const getDefectsNotifications = createSelector(
    (state) => get(state, 'defects'),
    (defects) => {
        const defectList = [];
        Object.keys(defects || {}).forEach((key) => {
            const defect = defects[key];
            if (!defect.isDownloaded) {
                defectList.push(defect);
            }
        });

        return defectList;
    }
);

export const getDefects = createSelector(
    getCurrentLeg,
    (state) => get(state, 'defects', {}),
    (leg = {}, defects) => {
        return get(leg, 'defectIds', []).map((defectId) => defects[defectId]);
    }
);

export const useDefects = () => useSelector(getDefects);

export const useHasDefects = () => 
    useSelector(() => {
        const defects = useDefects();

        return defects.length > 0;
    });

export const useDefectCounts = () => 
    useSelector(() => {
        const defects = useDefects();
        
        return {
            count: defects.length,
            notDownloaded: defects.filter(({ isDownloaded }) => !isDownloaded).length,
        };
    });

export const useLegDefectNotifications = () => 
    useSelector(() => {
        const defects = useDefects();
        
        return defects.filter(({ isDownloaded }) => !isDownloaded);
    });
